import * as R from 'ramda';
import { message } from 'antd';
import { lookup } from 'mime-types';
// Max size - 50Mb
export const FILE_MAX_SIZE = 50000000;

// Acceptable file types
const FILE_TYPES = [
  // *.pdf
  {
    ext: 'pdf',
    mimeType: lookup('pdf'),
  },
  // *.doc
  {
    ext: 'doc',
    mimeType: lookup('doc'),
  },
  // *.docx
  {
    ext: 'docx',
    mimeType: lookup('docx'),
  },
  // *.xls
  {
    ext: 'xls',
    mimeType: lookup('xls'),
  },
  // *.xlsx
  {
    ext: 'xlsx',
    mimeType: lookup('xlsx'),
  },
  // *.ppt
  {
    ext: 'ppt',
    mimeType: lookup('ppt'),
  },
  // *.pptx
  {
    ext: 'pptx',
    mimeType: lookup('pptx'),
  },
  // *.jpg, *.jpeg
  {
    ext: 'jpeg',
    mimeType: lookup('jpeg'),
  },
  {
    ext: 'jpg',
    mimeType: lookup('jpg'),
  },
  // *.png
  {
    ext: 'png',
    mimeType: lookup('png'),
  },
  // *.mp3
  {
    ext: 'mp3',
    mimeType: lookup('mp3'),
  },
  // *.zip
  {
    ext: 'zip',
    mimeType: lookup('zip'),
  },
  {
    ext: 'zip',
    mimeType: 'application/zip-compressed',
  },
  {
    ext: 'zip',
    mimeType: 'application/x-zip',
  },
  {
    ext: 'zip',
    mimeType: 'application/x-zip-compressed',
  },
  {
    ext: 'zip',
    mimeType: 'multipart/x-zip',
  },
];

export const FILE_MIME_TYPES = FILE_TYPES.map(({ mimeType }) => mimeType);
export const FILE_MIME_EXTS = R.pipe(
  R.map(({ ext }) => `.${ext}`),
  R.uniq,
  R.join(','),
)(FILE_TYPES);

/**
 * Map files and form an array of objects with needed data to the Attachment component
 *
 * formAttachmentsList :: [Files] -> [Object]
 */
export const formAttachmentsList = (files) => {
  const time = new Date();

  const getFileExtension = (fileType, fileName) => {
    const fileInfo =
      !R.isEmpty(fileType) &&
      FILE_TYPES.filter(({ mimeType }) => mimeType === fileType);

    if (fileInfo) {
      return fileInfo[0].ext;
    }

    return fileName.split('.').pop() || '---';
  };

  return files.map(file => ({
    _id: `${time.getTime()}-${file.name}`,
    name: file.name,
    size: file.size,
    extension: getFileExtension(file.type, file.name),
  }));
};

/**
 * Show notification to the user if files were rejected
 *
 * rejectedFilesErrors :: [Files] -> ...
 */
export const rejectedFilesErrors = (rejectedFiles) => {
  if (rejectedFiles && rejectedFiles.length > 0) {
    rejectedFiles.forEach(({ name, type, size }) => {
      if (size > FILE_MAX_SIZE) {
        message.error(`File '${name}' is too big!`, 5);
      }
      if (!R.isEmpty(type) && !FILE_MIME_TYPES.includes(type)) {
        message.error(`File '${name}' is unsupportable!`, 5);
      }
    });
  }
};

/**
 * Validate files from <input />
 *
 * validateFiles :: [Files] -> { [Files], [Files] }
 */
export const validateFiles = (files) => {
  const acceptedFiles = [];
  const rejectedFiles = [];

  if (files && files.length > 0) {
    files.forEach((file) => {
      const { type, size } = file;
      if (size > FILE_MAX_SIZE) {
        rejectedFiles.push(file);
      } else if (!R.isEmpty(type) && !FILE_MIME_TYPES.includes(type)) {
        rejectedFiles.push(file);
      } else {
        acceptedFiles.push(file);
      }
    });
  }
  return {
    acceptedFiles: [...new Set(acceptedFiles)],
    rejectedFiles: [...new Set(rejectedFiles)],
  };
};



// WEBPACK FOOTER //
// ./src/utils/files.js